import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	invalidDeleteModalTitle: {
		id: 'admin-pages-priority-schemes.delete-priority-scheme-modal.invalid-delete-modal-view.invalid-delete-modal-title',
		defaultMessage: 'The scheme is in use',
		description: 'Invalid delete priority scheme modal title',
	},
	invalidDeleteModalTitleNew: {
		id: 'admin-pages-priority-schemes.delete-priority-scheme-modal.invalid-delete-modal-view.invalid-delete-modal-title-new',
		defaultMessage: "We couldn't delete the priority scheme",
		description: 'Invalid delete priority scheme modal title',
	},
	invalidDeleteModalNAssociatedProjectDescriptionNew: {
		id: 'admin-pages-priority-schemes.delete-priority-scheme-modal.invalid-delete-modal-view.invalid-delete-modal-n-associated-project-description-new',
		defaultMessage:
			'{associatedProjectCount, plural, one {The scheme "{schemeName}" has {associatedProjectCount} associated project. Remove this project from the scheme to delete the scheme.} other {The scheme "{schemeName}" has {associatedProjectCount} associated projects. Remove these projects from the scheme to delete the scheme.}}',
		description: 'Invalid delete priority scheme modal description',
	},
	invalidDeleteModalCompleteButtonNew: {
		id: 'admin-pages-priority-schemes.delete-priority-scheme-modal.invalid-delete-modal-view.invalid-delete-modal-complete-button-new',
		defaultMessage: 'Ok',
		description: 'Invalid delete priority scheme modal close button title',
	},

	invalidDeleteModalDescription: {
		id: 'admin-pages-priority-schemes.delete-priority-scheme-modal.invalid-delete-modal-view.invalid-delete-modal-description.non-final',
		defaultMessage:
			'To delete the priority scheme "{schemeName}", you need to first remove all projects from it first.',
		description: 'Invalid delete priority scheme modal description',
	},
	invalidDeleteModalCompleteButton: {
		id: 'admin-pages-priority-schemes.delete-priority-scheme-modal.invalid-delete-modal-view.invalid-delete-modal-complete-button.non-final',
		defaultMessage: 'Ok got it',
		description: 'Invalid delete priority scheme modal close button title',
	},
});
